/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schemasGetDestinationType } from "../../funcs/schemasGetDestinationType.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  type: operations.GetDestinationTypeSchemaType$inboundSchema,
};

export const tool$schemasGetDestinationType: ToolDefinition<typeof args> = {
  name: "schemas-get-destination-type",
  description: `Get Destination Type Schema

Returns the input schema for a specific destination type.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await schemasGetDestinationType(
      client,
      args.type,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
